import { useEffect, useState } from "react";
import axios from "axios";
import styles from "./style.module.css";
import { NavLink } from "react-router-dom";
import AnnualReturn from "../../assets/user_guide_for_Annual_Return.pdf";
import esbnGuide from "../../assets/user_guide_for_ESBN.pdf";
import PAYE from "../../assets/user_guide_for_PAYE.pdf";
const coy_ANSSID = process.env.REACT_APP_ANSSID;

const Home = () => {
	const userInfo = JSON.parse(localStorage.getItem("user_info")) || {};
	const [anssidInfo, setAnssidInfo] = useState({});

	const getAnssid = async () => {
		const res = await axios
			.get(`/system/getuseranssid`)
			.then((res) => (res.data || {}).data);
		console.log(res);
		setAnssidInfo(res);
	};

	useEffect(() => {
		getAnssid();
	}, []);

	const handleDownload = (documentType) => {
		let pdfFilePath = " ";
		// /assets/user guide for ESBN.pdf
		switch (documentType) {
			case "ESBN":
				pdfFilePath = esbnGuide;
				break;
			case "PAYE":
				pdfFilePath = PAYE;
				break;
			case "AnnualReturn":
				pdfFilePath = AnnualReturn;
				break;
			default:
				return;
		}

		window.location.href = pdfFilePath;
	};

	return (
		<div className={styles.home}>
			<h1 className={styles.salutation}>
				Welcome,{" "}
				{userInfo.account_type === "corporate"
					? userInfo.corpname || userInfo?.firstname
					: userInfo.firstname}
			</h1>
			<p className={styles.basic}>
				Your data has been saved successfully.
				<br />
				Your {coy_ANSSID} number: <b>{anssidInfo.Anssid}</b>
				<br />
				Your registration date:{" "}
				<b>
					{new Date(
						anssidInfo.createdAt || Date.now()
					).toLocaleDateString()}
				</b>
			</p>
			<p className={styles.details}>
				Your email address: {userInfo.email} <br />
				{/* &lt;Verified&gt; */}
			</p>
			<p className={styles.details}>
				Your phone number: {userInfo.phonenumber}
				<br />
				{/* &lt;Unverified&gt; */}
				<br />
				{/* Click <NavLink to="/otp-phone">here</NavLink> to Verify */}
			</p>
			<p className={styles.details}>
				Please contact <NavLink to="/support">support</NavLink>, if you
				have any issues.
			</p>
			<div style={{ marginTop: "20%" }}>
				<select onChange={(e) => handleDownload(e.target.value)}>
					<option value="">Download User Guide</option>
					<option value="ESBN">ESBN</option>
					<option value="PAYE">PAYE</option>
					<option value="AnnualReturn">Annual Return</option>
				</select>
			</div>
		</div>
	);
};

export default Home;
